import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  List,
  ListItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { MenuManagementContext } from "pages/system-management/menu-management";
import { useContext, useState } from "react";
import RegistForm from "./regist-form";

const useStyles = makeStyles((theme) => ({
  codeGroup: {
    width: "100%",
    maxWidth: 620,
    fontSize: "12px",
  },
  alert: {
    justifyContent: "center",
  },
  root: {
    "& .MuiTypography-displayBlock": {
      fontSize: "12px",
    },
    "& .table": {
      maxWidth: "800px",
      "& th": {
        width: "140px",
      },
    },
    "& .button-area": {
      maxWidth: "800px",
    },
    "& .list-scroller": {
      height: "200px",
      overflowY: "auto",
    },
  },
  active: {
    background: "#EFEFEF",
  },
  action: {
    height: "30px",
  },
}));

export default function Regist() {
  const classes = useStyles();
  const {
    d1Menu,
    d2Menu,
    d3Menu,
    handleSelectCode,
    handleAddMenu,
    menuSort,
    selectMenu,
    handleSaveSort,
  } = useContext(MenuManagementContext);

  const [openSaveSortConfirm, setOpenSaveSortConfirm] = useState(false);
  const [sortDepth, setSortDepth] = useState("");

  const handleSort = (direction, depth) => {
    let list = JSON.parse(JSON.stringify(depth == "2" ? d2Menu : d3Menu));

    let sortItem = _.remove(list, (item) => {
      return item.cd == selectMenu.cd;
    })[0];

    if (direction == "up") {
      list.unshift(sortItem);
    } else {
      list.push(sortItem);
    }

    menuSort(list, depth);
  };

  const activeCheck = (depth, code) => {
    let result = false;
    let cd = "";

    if (!selectMenu.cd) return;

    if (depth == "depth1") {
      cd = selectMenu.cd.slice(0, 2);
      if (code == cd) result = true;
    } else if (depth == "depth2") {
      cd = selectMenu.cd.slice(0, 4);
      if (code == cd) result = true;
    } else {
      cd = selectMenu.cd.slice(0, 6);
      if (code == cd) result = true;
    }

    return result;
  };

  const handleSaveSortClick = (depth) => {
    setSortDepth(depth);
    setOpenSaveSortConfirm(true);
  };

  const handleSaveSortConfirmOk = () => {
    setOpenSaveSortConfirm(false);
    handleSaveSort(sortDepth);
  };

  return (
    <main id="main">
      <div className={classes.root}>
        <div className="h-group">
          <h2>관리자메뉴관리</h2>
        </div>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <h3>1Depth</h3>
            <Card>
              <CardContent className="p-0">
                <List
                  className="list-scroller"
                  component="nav"
                  aria-label="main mailbox folders"
                >
                  {d1Menu &&
                    d1Menu.map((list) => (
                      <ListItem
                        button
                        key={list.cd}
                        onClick={(event) => handleSelectCode(event, list.cd)}
                        className={
                          activeCheck("depth1", list.cd) && classes.active
                        }
                      >
                        {list.nm}
                      </ListItem>
                    ))}
                </List>
              </CardContent>
              {/* <hr /> */}
              <CardActions className={classes.action} />
            </Card>
            <Grid container spacing={3} className="mt-1">
              <Grid item xs={6}>
                <Box mt={1}>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={(e) => {
                      handleAddMenu("depth1");
                    }}
                  >
                    추가
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <h3>2Depth</h3>
            <Card>
              <CardContent className="p-0">
                <List
                  className="list-scroller"
                  component="nav"
                  aria-label="main mailbox folders"
                >
                  {d2Menu &&
                    d2Menu.map((list) => (
                      <ListItem
                        button
                        key={list.cd}
                        onClick={(event) => handleSelectCode(event, list.cd)}
                        className={
                          activeCheck("depth2", list.cd) && classes.active
                        }
                      >
                        {list.nm}
                      </ListItem>
                    ))}
                </List>
              </CardContent>
              {/* <hr /> */}
              <CardActions className={classes.action}>
                <Grid container>
                  <Grid item xs={12}>
                    {selectMenu && selectMenu.cd.length == 4 && (
                      <Box display="flex" justifyContent="flex-end">
                        <Box mr={1}>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleSort("up", 2);
                            }}
                          >
                            맨위▲
                          </a>
                        </Box>
                        <Box mr={1}>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleSort("down", 2);
                            }}
                          >
                            맨아래▼
                          </a>
                        </Box>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </CardActions>
            </Card>
            <Grid container spacing={3} className="mt-1">
              <Grid item xs={6}>
                <Box mt={1}>
                  {selectMenu && selectMenu.cd.length == 2 && (
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={(e) => {
                        handleAddMenu("depth2");
                      }}
                    >
                      추가
                    </Button>
                  )}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box mt={1} display="flex" justifyContent="flex-end">
                  {selectMenu && selectMenu.cd.length == 4 && (
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={(e) => {
                        handleSaveSortClick("depth2");
                        //handleSaveSort("depth2");
                      }}
                    >
                      정렬저장
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <h3>3Depth</h3>
            <Card>
              <CardContent className="p-0">
                <List
                  className="list-scroller"
                  component="nav"
                  aria-label="main mailbox folders"
                >
                  {d3Menu &&
                    d3Menu.map((list) => (
                      <ListItem
                        button
                        key={list.cd}
                        onClick={(event) => handleSelectCode(event, list.cd)}
                        className={
                          activeCheck("depth3", list.cd) && classes.active
                        }
                      >
                        {list.nm}
                      </ListItem>
                    ))}
                </List>
              </CardContent>
              {/* <hr /> */}
              <CardActions className={classes.action}>
                <Grid container>
                  {selectMenu && selectMenu.cd.length == 6 && (
                    <Grid item xs={12}>
                      <Box display="flex" justifyContent="flex-end">
                        <Box mr={1}>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleSort("up", 3);
                            }}
                          >
                            맨위▲
                          </a>
                        </Box>
                        <Box mr={1}>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleSort("down", 3);
                            }}
                          >
                            맨아래▼
                          </a>
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </CardActions>
            </Card>
            <Grid container spacing={3} className="mt-1">
              <Grid item xs={6}>
                <Box mt={1}>
                  {selectMenu && selectMenu.cd.length == 4 && (
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={(e) => {
                        handleAddMenu("depth3");
                      }}
                    >
                      추가
                    </Button>
                  )}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box mt={1} display="flex" justifyContent="flex-end">
                  {selectMenu && selectMenu.cd.length == 6 && (
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={(e) => {
                        handleSaveSortClick("depth3");
                        //handleSaveSort("depth3");
                      }}
                    >
                      정렬저장
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <Box mt={3}>
        <RegistForm />
      </Box>

      <Dialog
        open={openSaveSortConfirm}
        onClose={() => {
          setOpenSaveSortConfirm(false);
        }}
        className="alert-dialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">저장하시겠습니까?</DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setOpenSaveSortConfirm(false);
            }}
            color="secondary"
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveSortConfirmOk}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </main>
  );
}
